const isTest = location.hostname === 'cubewebapi.51ylk.com' // true
const config = {
  BASR_URL: isTest ? 'https://cubewebapi.51ylk.com' : 'https://wx.taiheiot.com',
  admin: false // 后台管理模式

}
export default config
